/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

export function jsonFormatter( key: string, value: unknown ): unknown {
	if ( value instanceof HTMLElement ) {
		if ( value.dataset.type === 'element' ) {
			return `__UNQUOTE__document.querySelector( '${ value.dataset.identifier }' )__UNQUOTE__`;
		}

		return `__UNQUOTE__${ value.dataset.identifier }__UNQUOTE__`;
	}

	if ( Array.isArray( value ) ) {
		if ( key === 'plugins' || key === 'extraPlugins' ) {
			return '__UNQUOTE__[ ' + value.join( ',' ) + ' ]__UNQUOTE__';
		}
	}

	if ( value instanceof RegExp ) {
		return `__UNQUOTE__${ value.toString() }__UNQUOTE__`;
	}

	return value;
}
